/**
 * Theme configurations for VisitorPage.
 * Returns Tailwind class strings for dark/light mode.
 */
export function getThemeClasses(darkMode) {
    if (darkMode) {
        return {
            bg: 'bg-gradient-to-br from-slate-900 via-indigo-950 to-slate-900 text-white',
            header: 'bg-black/20 backdrop-blur-md border-b border-white/10',
            bubble: 'bg-white/10 backdrop-blur-sm text-gray-100 rounded-tl-sm',
            userBubble: 'bg-blue-600 text-white rounded-tr-sm',
            systemBg: 'bg-white/10 text-gray-400',
            systemErr: 'bg-red-500/20 text-red-300',
            input: 'bg-white/10 border border-white/10 text-white placeholder-gray-500',
            inputBar: 'bg-black/20 backdrop-blur-md border-t border-white/10',
            scrollBtn: 'bg-white/20 backdrop-blur-sm text-white hover:bg-white/30',
            skillBadge: 'bg-white/20 backdrop-blur-sm',
            contactCard: 'bg-white/10 backdrop-blur-sm',
            suggestionBtn: 'bg-[#5764F4]/20 hover:bg-[#5764F4]/40 text-indigo-300 border-[#5764F4]/30',
            prose: 'prose-invert prose-a:text-indigo-300 prose-strong:text-white',
            caption: 'text-gray-400',
            time: 'text-gray-500',
            userTime: 'text-blue-200',
            avatarBot: 'bg-gradient-to-br from-[#5764F4] to-purple-500 text-white',
            avatarUser: 'bg-blue-500/30 text-blue-300',
            status: 'text-gray-400',
            welcomeText: 'text-gray-400',
            themeBtn: 'bg-white/10 hover:bg-white/20 text-white',
            videoBtn: 'bg-white/10 hover:bg-white/20 text-white',
        };
    }
    return {
        bg: 'bg-gray-50 text-gray-900',
        header: 'bg-white border-b border-gray-200 shadow-sm',
        bubble: 'bg-gray-100 text-gray-800 rounded-tl-sm',
        userBubble: 'bg-[#5764F4] text-white rounded-tr-sm',
        systemBg: 'bg-gray-200 text-gray-600',
        systemErr: 'bg-red-100 text-red-700',
        input: 'bg-white border border-gray-300 text-gray-900 placeholder-gray-400',
        inputBar: 'bg-white border-t border-gray-200',
        scrollBtn: 'bg-gray-700 text-white hover:bg-gray-800',
        skillBadge: 'bg-indigo-50 text-indigo-700',
        contactCard: 'bg-blue-50',
        suggestionBtn: 'bg-[#5764F4]/10 hover:bg-[#5764F4]/20 text-[#5764F4] border-[#5764F4]/20',
        prose: 'prose-a:text-indigo-600 prose-strong:text-gray-900',
        caption: 'text-gray-500',
        time: 'text-gray-400',
        userTime: 'text-indigo-200',
        avatarBot: 'bg-gradient-to-br from-[#5764F4] to-purple-500 text-white',
        avatarUser: 'bg-blue-100 text-blue-600',
        status: 'text-gray-500',
        welcomeText: 'text-gray-500',
        themeBtn: 'bg-gray-100 hover:bg-gray-200 text-gray-700',
        videoBtn: 'bg-gray-100 hover:bg-gray-200 text-gray-700',
    };
}
